import React from 'react';
import _ from 'lodash';
import { ReceiptType } from '~/Hooks';

import { HistoryOrder } from '..';
import { ContentWrapper } from './sharedStyles';
import { Receipt } from './Receipt';
import { Order } from './Order';
import { Customer } from './Customer';
import { PrintReceiptArgs } from '../view';
import CopyToTable from './CopyToTable';
import { PaymentInfo } from './PaymentInfo';

interface Props {
  selectedOrder: HistoryOrder;
  printReceipt: (args: PrintReceiptArgs) => void;
}

const SelectedOrder = ({ selectedOrder, printReceipt }: Props) => {

  if (!selectedOrder) {
    return null;
  }

  const printRefundReceiptCopy = (itemId?: string) => {
    printReceipt({
      type: ReceiptType.Refund,
      order: selectedOrder,
      cardDetails: selectedOrder.payment?.metadata?.cardDetails,
      itemId,
      isCopy: true,
    });
  };

  return (
    <ContentWrapper>
      <Receipt order={selectedOrder} handlePrintReceiptCopy={printRefundReceiptCopy} />
      <Order order={selectedOrder} />
      <Customer order={selectedOrder} />
      <PaymentInfo order={selectedOrder} />
      <CopyToTable order={selectedOrder} />
    </ContentWrapper>
  );
};

export default SelectedOrder;
